import { createAction } from 'redux-actions';

const action = createAction('SET_JOB_APPLICANT_JOB_MESSAGES_DIRTY');
export const setJobApplicantJobMessagesDirty = (jobId: number) => action({ jobId });
